<script lang="ts" setup>
import type { PropType } from "vue";
import { RouteLocationRaw } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

defineProps({
  to: {
    type: Object as PropType<RouteLocationRaw>,
    default: () => ({})
  }
});

const emits = defineEmits(["click"]);

// 親コンポーネントで @click を利用するケースがあるため、イベントをハンドリングしている
// 他コンポーネントでも RouterLink において to ではなく @click を利用したい場合、同様に対応する必要がある
function onClick() {
  emits("click");
}
</script>

<template>
  <RouterLink :to="to" class="add-qualification-item" @click="onClick">
    <FeatherIcon icon="plus-circle" size="16" class="mr-2" />
    <span class="text-gray-05">資格を追加</span>
  </RouterLink>
</template>

<style lang="scss" scoped>
.add-qualification-item {
  display: flex;
  align-items: center;
  padding: 16px;
  color: $gray-05;
  border: 1px dashed $gray-04;
  border-radius: 4px;
}
</style>
